import React from 'react';
import PropTypes from 'prop-types';

import Grid from '@material-ui/core/Grid';

import { Field, reduxForm } from 'redux-form';

import AutosuggestField from 'components/fields/AutosuggestField';

import documents from 'config/documents';

const CMNs = documents.filter(item => item.Type === 'CMS').map(item => item.Name);

function validateForm(values) {
  const errors = {};
  if (values['CMN/AMB'] && CMNs.indexOf(values['CMN/AMB']) === -1) {
    errors['CMN/AMB'] = 'Please, select CMN/AMB from list';
  }
  return errors;
}

const CMNSelectionForm = ({ handleSubmit, className }) => (
  <form
    noValidate
    autoComplete="off"
    onSubmit={handleSubmit}
    className={className}
    role="presentation"
    onKeyDown={(event) => {
      if (event.key === 'Enter') {
        event.preventDefault();
        event.stopPropagation();
      }
    }}
  >
    <Grid
      container
      justify="center"
      spacing={24}
    >
      <Grid
        item
        xs={12}
      >
        <Field
          id="CMN/AMB"
          name="CMN/AMB"
          component={AutosuggestField}
          placeholder="-Select CMN Type-"
          fullWidth
          renderSuggestionContent={suggestion => suggestion}
          onSuggestionSelected={suggestion => suggestion}
          fetchSuggestions={({ value, offset }) => (new Promise((resolve) => {
            if (offset === 0) {
              if (value.length > 0) {
                resolve(CMNs.filter(item =>
                  item.toLowerCase().indexOf(value.toLowerCase()) !== -1));
              } else {
                resolve(CMNs);
              }
            } else {
              resolve([]);
            }
          }))}
        />
      </Grid>
    </Grid>
  </form>
);

CMNSelectionForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  className: PropTypes.string,
};

CMNSelectionForm.defaultProps = {
  className: '',
};

export default reduxForm({
  onSubmit: values => values,
  validate: validateForm,
})(CMNSelectionForm);



// WEBPACK FOOTER //
// ./src/components/workflow/CMNSelectionDialog/CMNSelectionForm.js